import { Notification } from '@dtpk-cc/components';
import { pluginSettingsVar } from '../../../apollo/store';

export const NoProductsAvailableError = () => {
    const { noProductsAvailable } = pluginSettingsVar();

    return (
        <Notification variant={Notification.Variant.alert} closable={false} noSideMargins noBottomMargin>
            <Notification.CopyText data-test-error="no_products">
                <div dangerouslySetInnerHTML={{ __html: noProductsAvailable || 'Fehler' }} />
            </Notification.CopyText>
        </Notification>
    );
};
